import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { PD7AData } from "./types";

export function usePD7A(enabled: boolean) {
  return useQuery<PD7AData>({
    queryKey: ["payroll-tax-print-pd7a"],
    queryFn: async () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const r = await apiFetch(
        "/api/v1/payroll/taxes/pd7a?year=" + year + "&month=" + month,
        { headers: authHeaders() }
      );
      if (!r.ok) throw new Error("HTTP " + r.status);
      return (await r.json()) as PD7AData;
    },
    enabled,
    refetchOnWindowFocus: false,
  });
}